import { render, staticRenderFns } from "./GoldEventManageModal.vue?vue&type=template&id=18d53108&"
import script from "./GoldEventManageModal.vue?vue&type=script&lang=js&"
export * from "./GoldEventManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports